import React, {useState} from 'react';
import {useLocation,useParams} from 'react-router-dom';
import Helmet from 'react-helmet';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import {getUseParams} from '../utils/baseUtil';
import OpenApp from '../components/OpenApp';
import PersonDetail from '../components/qa/Person';

dayjs.locale('zh-cn');

const Person = (props) => {
  const location = useLocation();
  const params = useParams()
  const query = location.search?getUseParams(location.search): params;
  const type = props.type;
  const [title, setTitle] = useState('');

  return (
    <>
      <Helmet>
        <body className="bg-c-0f1214ffffff s-body person-list" />
        <title>{title}</title>
        <link rel="stylesheet" href={`${process.env.REACT_APP_OSS_HOST}/css/2025071/person_2025071.css`}/>
      </Helmet>
      <OpenApp openUrl={(!!query.id && type === 'proficient') ? `lanjing://${type}?detail_id=${query.id}` : ''} />
      <PersonDetail
        type={type}
        changeTitle={(title) => setTitle(title)} 
        openUrl={(!!query.id && type === 'proficient') ? `lanjing://${type}?detail_id=${query.id}` : ''}
      />
    </>
  );
};

export default Person;